
/*
  
para las url externas, hay que manejar los queryparams como base64 con hash
import crypto from "crypto-js";
crypto.SHA512(plain_text).toString()

var encodedStringBtoA = btoa(decodedStringBtoA);
var decodedStringAtoB = atob(encodedStringAtoB);

*/

export default class AuthService {

	async VerifyConexion() {
		const requestOptions = {
			method: 'POST',
			mode: 'cors',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }
		};

		const data = await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/Auth/VerifyConexion', requestOptions).then(res => res.json())
			.catch(error => {
				console.log("El servicio no está funcionando , ", data);
				return false;
			});

		return true;

	}

	async getSuscripcionFromSubdomain(subdomain) {
		console.log("getSuscripcionFromSubdomain, ");
		
		const requestOptions = {
			method: 'POST',
			mode: 'cors',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },

			//body: JSON.stringify({ 'idEmpresa': 1, 'idioma':'ES', 'userName':'1102817706' })
		};

		return await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/Auth/GetSuscripcionFromSubdomain/?subdomain=' + subdomain, requestOptions).then(res => res.json());

	}

	async login(idSuscripcion, idEmpresa, idioma, userName, password) {

		const requestOptions = {
			method: 'POST',
			mode: 'cors',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },

			body: JSON.stringify({ 'idSuscripcion': idSuscripcion, 'idEmpresa': idEmpresa, idioma: idioma, 'userName': userName, 'password': password })
		};
		try {
			let respuesta = await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/Auth/login/', requestOptions);

			let data = await respuesta.json();
			return data;

			/*
			let token = await respuesta.json();

			if(respuesta.status === 200 && respuesta.ok ===true ){
				let data = { loginOK : true , userName: userName, idEmpresa: idEmpresa, idioma: idioma , token: token}
				return data;
			}
			else{
				let data = { loginOK : false, error:"ERROR"}
				return data;
			}*/


		}
		catch (exception) {
			let data = { loginOK: false, error: "ERROR" }
			return data;
		}

	}

	async loginVisitUser(idSuscripcion, idEmpresa, idioma, userName, password, documentoInvitado) {

		const requestOptions = {
			method: 'POST',
			mode: 'cors',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },

			body: JSON.stringify({ 'idSuscripcion': idSuscripcion, 'idEmpresa': idEmpresa, idioma: idioma, 'userName': userName, 'password': password, 'documentoInvitado': documentoInvitado })
		};
		try {
			let respuesta = await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/Auth/LoginVisitUser/', requestOptions);

			let data = await respuesta.json();
			return data;

			/*
			let token = await respuesta.json();

			if(respuesta.status === 200 && respuesta.ok ===true ){
				let data = { loginOK : true , userName: userName, idEmpresa: idEmpresa, idioma: idioma , token: token}
				return data;
			}
			else{
				let data = { loginOK : false, error:"ERROR"}
				return data;
			}*/


		}
		catch (exception) {
			let data = { loginOK: false, error: "ERROR" }
			return data;
		}

	}



	async GetTokenAutorization(userName, sessionGUID) {
		const requestOptions = {
			method: 'POST',
			mode: 'cors',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },

			body: JSON.stringify({ 'userName': userName, 'sessionGUID': sessionGUID })
		};

		return await (await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/Auth/GetTokenAutorization/', requestOptions)).json();

	}

	async getClientIP() {

		const requestOptions = {
			method: 'GET',
			mode: 'cors',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },

			//body: JSON.stringify({ 'idSuscripcion': idSuscripcion, 'idEmpresa': idEmpresa, idioma: idioma, 'userName': userName, 'password': password, 'documentoInvitado': documentoInvitado })
		};
		try {
			let respuesta = await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/Auth/GetClientIp/', requestOptions);

			let data = await respuesta.json();
			return data;

		}
		catch (exception) {
			let data = { loginOK: false, error: "ERROR" }
			return data;
		}

	}


}
